import { PlusOutlined } from "@ant-design/icons";
import {
  Button,
  // Descriptions,
  Flex,
  Input,
  InputNumber,
  Modal,
  Radio,
  Select
} from "antd";
import { ReactElement, useEffect, useMemo, useState } from "react";
// import { toast } from "react-toastify";

import styles from "./AddConfigurationModal.module.scss";

import { EntityIdentifierEnums } from "../../api";
import { getDefaultImportConfiguration } from "../../api/template/template";
import { useUserData } from "../../hooks/useUserProfile";
// import { useAppSelector } from "../../store/hooks/hooks";
// import { selectParseResult } from "../../store/slices/parseResultSlice";
// import { createErrorMessage } from "../../utils/createErrorMessage";
import { ImportConfigurationArgument } from "../../types/importConfiguration";
import { Description } from "../Description";
import { CustomButton } from "../FormFields/CustomButton";
import { Title } from "../Title";


type AddConfigurationModalProps = {
    action?: Function;
    sheetName: string;
    sheetNames: string[];
    headerRow: number | null;
    dataRow: number | null;
};

export const AddConfigurationModal = ({
    sheetNames,
    action,
    sheetName,
    headerRow,
    dataRow,
}: AddConfigurationModalProps): ReactElement => {
    const { organizationId, tenantId } = useUserData();
    const destinationIdentifierOptions = useMemo(() => Object.entries(EntityIdentifierEnums).map(([value, label]) => {
      return {
          value,
          label,
      };
    }), []);
    
    // const parseResult = useAppSelector(selectParseResult);
    const [open, setOpen] = useState(false);
    const [reportDestinationIdentifier, setReportDestinationIdentifier] = useState(destinationIdentifierOptions[0].value); // TODO: get from props or context
    const [configurationName, setConfigurationName] = useState(""); //parseResult.fileId.replace(/^[^_]*_/, "")
    const [newSheetName, setNewSheetName] = useState(sheetName);
    const [newHeaderRow, setNewHeaderRow] = useState(headerRow || 1);
    const [newDataRow, setNewDataRow] = useState(dataRow || 2);

    useEffect(() => {
        if (dataRow) setNewDataRow(dataRow);
    }, [dataRow]);

    useEffect(() => {
        if (headerRow) setNewHeaderRow(headerRow);
    }, [headerRow]);

    useEffect(() => {
        if (sheetName) setNewSheetName(sheetName);
    }, [sheetName]);

    const sheetNameOptions = useMemo(() => {
        return sheetNames.map((value) => ({
            value,
            label: value,
        }));
    }, [sheetNames]);

    const items = useMemo(() => [
      {
          key: 5,
          label: "Configuration name",
          children: <Input type="text" variant="borderless" value={configurationName} onChange={(e) => { setConfigurationName(e.target.value) }}/>,
      },
      {
          key: 0,
          label: "Sheet name",
          children: <Select variant="borderless" options={sheetNameOptions} value={newSheetName} onSelect={(value) => setNewSheetName(value)}/>,
      },
      {
          key: 1,
          label: "Report name",
          children: <Select
            variant="borderless"
            options={destinationIdentifierOptions}
            value={reportDestinationIdentifier}
            onChange={(value) => {setReportDestinationIdentifier(value)}}
          />,
      },
      {
          key: 2,
          label: "Header row",
          children: <InputNumber variant="borderless" value={newHeaderRow} onChange={(value) => { setNewHeaderRow(value || 1) }}/>,
      },
      {
          key: 3,
          label: "Data row",
          children: <InputNumber variant="borderless" value={newDataRow} onChange={(value) => { setNewDataRow(value || 1) }}/>,
      },
    ], [configurationName, newDataRow, newHeaderRow, newSheetName, reportDestinationIdentifier, sheetNameOptions]);

    const handleSave = async() => {
        const res = await getDefaultImportConfiguration(organizationId,
          tenantId,
          "ExcelAdapter",
          reportDestinationIdentifier);
        
        if (res?.data?.success && res?.data?.data) {
          const defaultConfig = res.data.data;

          const newConfig = {
              ...defaultConfig     ,      
              name: configurationName,
              sourceIdentifier: newSheetName,
              importConfigurationArguments: defaultConfig?.importConfigurationArguments?.map((a: ImportConfigurationArgument) => {
                if (a.identifier === "HeaderRowIndex") {
                  return {
                    ...a,
                    value: newHeaderRow,
                  };
                } else if (a.identifier === "FirstDataRowIndex") {
                  return {
                    ...a,
                    value: newDataRow,
                  };
                }

                return a;
            })
          };
        
          action?.(newConfig);
        }
    }

    return (
        <div className={styles.root}>
          <Modal
            title={<Title tagName="h4">Add new configuration</Title>}
            open={open}
            onOk={handleSave}
            onCancel={() => { setOpen(false) }}
            width={600}
            footer={null}
            okButtonProps={{ disabled: true }}
            cancelButtonProps={{ disabled: true }}
            okText="Save"
            cancelText="Cancel"
          >
            <Flex vertical gap={16}>
              <Description theme="t2">Choose the report type this configuration will be used for</Description>
              <Radio.Group

                options={destinationIdentifierOptions}
                value={reportDestinationIdentifier}
                onChange={(e) => setReportDestinationIdentifier(e.target.value)}
                optionType="button"
                buttonStyle="solid"
              />
              <Description theme="t2">Enter a name for this configuration:</Description>
              <Input
                type="text"
                placeholder="Configuration name"
                variant="underlined"
                value={configurationName}
                onChange={(e) => { setConfigurationName(e.target.value) }}
              />
            </Flex>
            {/* <Descriptions
              size="middle"
              layout="horizontal"
              bordered
              column={1}
              items={items}
            /> */}
            <Flex justify="end" gap={8} style={{ marginTop: 16 }}>
              <Button type="link" variant="link" size="large" onClick={() => setOpen(false)}>Cancel</Button>
              <CustomButton theme="secondary" onClick={() => {
                handleSave();
                setOpen(false);
              }}>
                Save
              </CustomButton>
            </Flex>

          </Modal>
          <CustomButton onClick={() => { setOpen(true); }}><PlusOutlined /> Add configuration</CustomButton>
        </div>
    );
};